"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.state = void 0;
const pixel_pigeon_1 = require("pixel-pigeon");
exports.state = new pixel_pigeon_1.State({
    battleState: null,
    constants: null,
    defaultClothesDyeID: null,
    defaultHairDyeID: null,
    defaultMaskID: null,
    defaultOutfitID: null,
    initialBankTilePositions: [],
    initialChestTilePositions: [],
    initialCombinationLockTilePositions: [],
    initialEnterableTilePositions: [],
    initialNPCExtenderPositions: [],
    initialNPCTilePositions: [],
    initialPianoTilePositions: [],
    isSubscribed: false,
    mainMenuState: null,
    pianoStartedAt: null,
    selectedPlayerID: null,
    serverURL: null,
    worldState: null,
});
